export default "__VITE_ASSET__e2fa9c26__"